import React, {useContext, useState, useEffect, useReducer} from 'react';
import { NavLink } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'

const  Sidebar = (props) => {    

  const {userInfo} = useContext(AuthContext);

return ( 

<aside id="sidebar-wrapper">
    <div className="sidebar-brand">
      <img src="/pmf-white-logo.png" style={{width:'90px'}}/>
    </div>
    
    <ul className="sidebar-nav">
    <li>
        <NavLink   to="/registration/guidelines"> <i className="fa fa-bullhorn"></i>  Guidelines </NavLink>
      </li>

      <li>
        <NavLink   to="/registration/dashboard"> <i className="fa fa-bar-chart-o"></i>  Dashboard </NavLink>
      </li>

      {!userInfo.isPortalLocked && !userInfo.isCIPInstitute ? (<>
        <li>
        <NavLink   to="/registration/application"> <i className="fa fa-drivers-license"></i>Apply Registration </NavLink>
      </li> 
      </>): (null)}


      <li >
        <NavLink  to="/registration/students"> <i className="fa fa-dropbox"></i>  Applications </NavLink>
      </li>

      {userInfo.isProcessOfScrutinyStarted ? (<>
        <li >
          <NavLink style={{fontWeight: 'bold', color:'crimson'}}  to="/registration/applications/registered"> <i className="fa fa-registered"></i> Registered Students  </NavLink>
        </li>
        <li>
          <NavLink  to="/registration/applications/rejected"> <i className="fa fa-times-circle text-danger"></i>  Objections </NavLink>        
        </li>
      </>): (null)}

      {/* <li>
        <NavLink  to="/registration/applications/corrected"> <i className="fa fa-pencil-square-o"></i>  Corrected Applications </NavLink>        
      </li>*/
      }

      <li >
        <NavLink  to="/registration/print"> <i className="fa fa-file-pdf-o"></i>  Print  </NavLink>
      </li>            
    </ul>
  </aside>
    
    )
}


export default Sidebar;
